import HomeTopDesc from "../components/home/HomeTopDesc";
import HomeBottomDesc from "../components/home/HomeBottomDesc";
import ScrollToTop from "../components/common/ScrollToTop";
import { Helmet } from "react-helmet-async";

interface MapCountProps {
    mapCount: (...args: any) => any;
}

/**
 * @author sukim91
 * @date 2022-09-28 15:18:22
 * @remark 가이드 페이지 스크린
 * @param props MapCountProps
 * @props MapCountProps
 *      mapCount(required) : 지도 카운트 결과값
 * @returns <UserGuide>
 */
function HomeScreen(props: MapCountProps) {
    ScrollToTop();
    return (
        <>
            <Helmet>
                <title>모두의지도</title>
                <meta name="description" content="모두의지도는 위치 정보를 활용하여 지도에 표현합니다." />
            </Helmet>
            <HomeTopDesc />
            <HomeBottomDesc mapCount={props.mapCount} />
        </>
    );
}

export default HomeScreen;
